<template>
  <div class="md:w-[300px] h-fit flex flex-none flex-col gap-[4px]">
    <label v-if="label.length" class="flex flex-row-reverse justify-between items-center h-[21px]" for="fname">
			<span class="material-symbols-rounded text-grays-700 text-base">
				<slot name="label_icon"></slot>
			</span>
      <p
          :class="disabled ? 'text-grays-600' : ''"
          class="text-grays-700 text-sm font-regular"
      >
        {{ label }}
      </p>
    </label>
    <div ref="defaultInput"
         :class="[disabled ? 'bg-grays-200  hover:border-grays-400' : '']"
         class="w-full py-[7px] px-[12px] flex flex-row-reverse items-center justify-between gap-[8px] rounded border border-grays-400 bg-white hover:border-grays-600"
    >
      <slot name="right_icon"></slot>
      <input
          id="fpassword"
          :class="disabled ? 'text-grays-600 placeholder:text-grays-600' : ''"
          :disabled="disabled"
          :placeholder="placeholder"
          :type="passwordVisibility ? 'text' : 'password'"
          :value="modelValue"
          class="flex flex-1 outline-none bg-transparent font-regular text-base text-grays-900 placeholder:text-grays-700"
          name="fpassword"
          v-bind="$attrs"
          @blur="restoreBorderColor"
          @focus="changeBorderColor"
          @input="updateInput"
      >
      <slot name="left_icon"></slot>
    </div>
    <error-block
        v-if="error && errorMessage.length"
        :errorMessage="errorMessage"
    />
  </div>
</template>

<script>
import ErrorBlock from "@/components/Global/ErrorBlock.vue";

export default {
  name: "input-password",
  components: {ErrorBlock},
  props: {
    label: {
      type: String,
      default: "",
    },
    modelValue: [String, Number],
    placeholder: {
      type: String,
      default: "",
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: '',
    },
    passwordVisibility: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    changeBorderColor() {
      if (!this.error) {
        this.$refs.defaultInput.style.borderColor = "#484848"
      }
    },
    restoreBorderColor() {
      if (!this.error && this.$refs.defaultInput) {
        this.$refs.defaultInput.style.borderColor = ""
      }
    },
    errorBorderStyle() {
      if (this.$refs.defaultInput) {
        this.$refs.defaultInput.style.borderColor = this.error ? "#EC3E45" : "";
      }
    },
    updateInput(e) {
      this.$emit('update:modelValue', e.target.value);
    },
  },
  mounted() {
    this.errorBorderStyle()
  },
  watch: {
    error() {
      this.errorBorderStyle()
    }
  }
}
</script>

<style>

</style>